import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { hideNotification } from "../../actions";
import { areThereNotifications } from "../../functions";
import NotificationsTransition from "../NotificationsTransition";
import Notification from "./Notification";
// RTL languages
const RTL_LANGUAGES = ["fa", "ar", "he"];
const useStyles = makeStyles()(() => {
    return {
        container: {
            position: "absolute",
            left: "16px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "auto",
            maxWidth: "720px",
            zIndex: 600,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            // Mobile: position at bottom of screen
            "@media (max-width: 768px)": {
                top: "auto",
                bottom: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "calc(100% - 32px)",
                maxWidth: "none",
                alignItems: "center",
            },
        },
        containerPortal: {
            width: "auto",
            maxWidth: "90%",
        },
    };
});
const NotificationsContainer = ({ _iAmSipGateway, _notifications, dispatch, portal }) => {
    const { classes, cx } = useStyles();
    const { i18n } = useTranslation();
    // Determine text direction based on current language
    const isRTL = RTL_LANGUAGES.includes(i18n.language?.split("-")[0] || "en");
    const _onDismissed = useCallback((uid) => {
        dispatch(hideNotification(uid));
    }, []);
    if (_iAmSipGateway) {
        return null;
    }
    return (React.createElement("div", { className: cx(classes.container, {
            [classes.containerPortal]: portal,
        }), dir: isRTL ? "rtl" : "ltr", id: "notifications-container" },
        React.createElement(NotificationsTransition, null, _notifications.map(({ props, uid }) => (React.createElement(Notification, { ...props, key: uid, onDismissed: _onDismissed, uid: uid }))) || null)));
};
/**
 * Maps (parts of) the Redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { notifications } = state["features/notifications"];
    const { iAmSipGateway } = state["features/base/config"];
    const { isOpen: isChatOpen } = state["features/chat"];
    const _visible = areThereNotifications(state);
    return {
        _iAmSipGateway: Boolean(iAmSipGateway),
        _isChatOpen: isChatOpen,
        _notifications: _visible ? notifications : [],
    };
}
export default connect(_mapStateToProps)(NotificationsContainer);
